import { render, staticRenderFns } from "./opintosuoritukset.vue?vue&type=template&id=03b52462&scoped=true&"
import script from "./opintosuoritukset.vue?vue&type=script&lang=ts&"
export * from "./opintosuoritukset.vue?vue&type=script&lang=ts&"
import style0 from "./opintosuoritukset.vue?vue&type=style&index=0&id=03b52462&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b52462",
  null
  
)

export default component.exports